module.exports = __webpack_public_path__ + "img/Frame 1110three1.292e2f9d.png";